import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import Hgroup from "public-components/Hgroup";
import Container from "public-components/Container";
import "slick-carousel/slick/slick.css";
import styles from "./TestimonialsSection.module.scss";

import QuoteIcon from "./quote.svg";
import StarIcon from "./star.svg";
import HalfStarIcon from "./half-star.svg";

import CircleBG from "assets/background/circle.svg";

const sliderConfig = {
  arrows: false,
  slidesToShow: 1,
  dots: true
};

const Rate = ({ rate }) => {
  const hasHalfStar = rate % 1 !== 0;
  const fullStarCount = Math.floor(rate);
  return (
    <div className={styles.rate}>
      {[...Array(5).keys()].map(i => {
        if (i + 1 <= fullStarCount) {
          return <StarIcon className={styles.fullStar} key={`star-${i}`} />;
        }
        if (hasHalfStar && i === fullStarCount) {
          return <HalfStarIcon className={styles.halfStar} key={`star-${i}`} />;
        }
        return <StarIcon className={styles.disabledStar} key={`star-${i}`} />;
      })}
    </div>
  );
};

const TestimonialsSection = ({ data }) => {
  return (
    <section className={styles.testimonials}>
      <CircleBG className={styles.testimonials__circle} />
      <Container>
        <Hgroup className={styles.testimonials__hgroup} heading={data.headingH2} />
        <Slider {...sliderConfig}>
          {data.homeTestimonialsList.map(i => (
            <div className={styles.testimonial} key={i.id}>
              <QuoteIcon className={styles.testimonial__icon} />
              <blockquote
                className={styles.testimonial__quote}
                dangerouslySetInnerHTML={{ __html: i.quote }}
              />
              <strong className={styles.testimonial__author}>{i.author}</strong>
              <p className={styles.testimonial__company}>{i.company}</p>
              <Rate rate={+i.rate} />
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

TestimonialsSection.propTypes = {
  data: PropTypes.shape({
    headingH2: PropTypes.string.isRequired,
    homeTestimonialsList: PropTypes.arrayOf(PropTypes.object)
  }).isRequired
};

export default TestimonialsSection;
